const statusStyles = {
    Vigente: "tw-border-green-500 tw-bg-green-50 tw-text-green-700",
    "Por vencer": "tw-border-amber-500 tw-bg-amber-100 tw-text-amber-700",
    Vencido: "tw-border-rose-500 tw-bg-rose-100 tw-text-rose-700",
    };

    export default function ProductStatusBadge({ status }) {
    const normalizedStatus = status || "Sin estado";
    const className =
        statusStyles[normalizedStatus] ||
        "tw-border-slate-300 tw-bg-slate-100 tw-text-slate-600";

    return (
        <span
        className={`tw-inline-flex tw-items-center tw-rounded-full tw-border tw-px-2 tw-py-0.5 tw-text-xs tw-font-semibold ${className}`}
        >
        {normalizedStatus}
        </span>
    );
}